// eslint-disable-file react/no-array-index-key
import React, { useEffect, useRef } from 'react';
import { useMap } from './MapContext';
import { LAYER_TYPES } from './constants/layerTypes';
import GenericTileLayer from './layers/GenericTileLayer';
import GenericVectorLayer from './layers/GenericVectorLayer';
import GenericWMSLayer from './layers/GenericWMSLayer';
const Map = ({
  layers,
  children
}) => {
  const mapRef = useRef();
  const map = useMap();
  useEffect(() => {
    map.setDomElement(mapRef.current);
  }, [map, mapRef.current]);
  return /*#__PURE__*/React.createElement("div", {
    id: "map",
    ref: mapRef,
    className: "ol-map"
  }, Object.entries(layers).map(([layerName, layerOptions], layerIdx) => {
    const idx = layerIdx;
    if (layerOptions?.type === LAYER_TYPES.TILE) {
      return /*#__PURE__*/React.createElement(GenericTileLayer, {
        key: idx,
        name: layerName,
        map: map,
        zIndex: layerIdx,
        layer: layerOptions
      });
    }
    if (layerOptions?.type === LAYER_TYPES.VECTOR) {
      return /*#__PURE__*/React.createElement(GenericVectorLayer, {
        key: idx,
        name: layerName,
        map: map,
        zIndex: layerIdx,
        layer: layerOptions
      });
    }
    if (layerOptions?.type === LAYER_TYPES.WMS) {
      return /*#__PURE__*/React.createElement(GenericWMSLayer, {
        key: idx,
        name: layerName,
        map: map,
        zIndex: layerIdx,
        layer: layerOptions
      });
    }
    throw new Error(`Unknown layer type: ${layerOptions?.type}`);
  }), children);
};
export default Map;